import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { Route } from '../Routes';
import CompaniesAndMapView from '../../containers_v2/client-companies/CompaniesAndMapView';
import { BuildingComplex } from 'lucide-react';
import { PrimaryColor } from '../../styles/global/css/Utils';

function CompaniesRoutes(): Route[] {
	return [
		{
			component: CompaniesAndMapView,
			path: '/companies',
			name: <Translate id="sidebar.accounts" />,
			role: ['all'],
			key: 'companies',
			sectionKey: 'companies',
			logoImg: <BuildingComplex size='16' />,
			hoverImg: <BuildingComplex color={PrimaryColor} size='16' />,
			activeImg: <BuildingComplex color={PrimaryColor} size='16' />,
			title: <Translate id="companies" />,
			subTitle: 'companies',
			restricted: false,
			exact: true,
			menu: true,
			permission: ['ViewCompany', 'ViewContact'],
			subroutes: [
				{ path: '/companies', name: <Translate id="company.beta" />, permission: ['ViewCompany'] },
				// { path: '/contacts', name: <Translate id="contacts" />, permission: ['ViewContact'] },
				{ path: '/contacts-v2', name: <Translate id="contacts" />, permission: ['ViewContact'] }
			]
		}
	];
}

export default CompaniesRoutes;
